module.exports = __webpack_public_path__ + "static/media/icon8.624e6dfe.svg";